import QueryTags from '../types/QueryTags'
import { EndpointBuilder } from '@reduxjs/toolkit/dist/query/endpointDefinitions'
import { BaseQueryFn, FetchArgs, FetchBaseQueryError, FetchBaseQueryMeta } from '@reduxjs/toolkit/query/react'

const basePath = 'membership/variable-expenses'

const variableExpensesEndpoints = (builder: EndpointBuilder<
  BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError, {}, FetchBaseQueryMeta>, QueryTags, 'data'>) =>
({
  fetchVariableExpenses: builder.query<any, { pageNumber?: number; pageSize?: number; sortBy?: string; sortDir?: 'asc' | 'desc' }>({
    query: ({ pageNumber = 0, pageSize = 10, sortBy, sortDir } = {}) => {
      const params = new URLSearchParams()
      params.set('pageNumber', String(pageNumber))
      params.set('pageSize', String(pageSize))
      if (sortBy) params.set('sortBy', sortBy)
      if (sortDir) params.set('sortDir', sortDir)
      return { url: `${basePath}?${params.toString()}`, method: 'get' }
    },
    providesTags: ['variable-expenses'],
  }),

  createVariableExpense: builder.mutation<any, any>({
    query: (body) => ({
      url: `${basePath}/create`,
      method: 'post',
      body,
    }),
    invalidatesTags: ['variable-expenses'],
  }),

  updateVariableExpense: builder.mutation<any, { id: number; body: any }>({
    query: ({ id, body }) => ({
      url: `${basePath}/${id}`,
      method: 'put',
      body,
    }),
    invalidatesTags: ['variable-expenses'],
  }),

  deleteVariableExpense: builder.mutation<any, number>({
    query: (id) => ({
      url: `${basePath}/${id}`,
      method: 'delete',
    }),
    invalidatesTags: ['variable-expenses'],
  }),

  fetchVariableExpensesReport: builder.query<any, { startDate: string; endDate: string }>({
    query: ({ startDate, endDate }) => ({
      url: `${basePath}/report?startDate=${startDate}&endDate=${endDate}`,
      method: 'get',
    }),
  }),

  reviewVariableExpense: builder.mutation<any, { id: number; accountId: number; feeAmount?: number }>({
    query: ({ id, accountId, feeAmount = 0 }) => ({
      url: `${basePath}/${id}/review`,
      method: 'post',
      body: { accountId, feeAmount },
    }),
    invalidatesTags: ['variable-expenses', 'running-dashboard'],
  }),

  updateReviewedVariableExpense: builder.mutation<any, { id: number; accountId: number; feeAmount?: number }>({
    query: ({ id, accountId, feeAmount = 0 }) => ({
      url: `${basePath}/${id}/review`,
      method: 'put',
      body: { accountId, feeAmount },
    }),
    invalidatesTags: ['variable-expenses', 'running-dashboard'],
  }),
})

export default variableExpensesEndpoints
